import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CircularProgress, Checkbox, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField, InputAdornment, AppBar, Toolbar, IconButton, Typography } from '@material-ui/core'
import { show, success as changeSuccess } from '../../../store/actions/actions.action'
import { rootUrl } from '../../../config/App'
import { SortableContainer, SortableElement } from 'react-sortable-hoc'
import { FaTrash } from 'react-icons/fa'
import { MdKeyboardBackspace, MdDelete } from 'react-icons/md'
import MaskedInput from 'react-text-mask'
import { changeScreen } from '../../../store/actions/navigation.action'
import { CKEditor } from 'ckeditor4-react'

const TextMaskCustom = (props) => {
    const { inputRef, ...other } = props;
    let mask = [];

    if (props.name === 'date') {
        mask = [/[0-9]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
    }

    if (props.name === 'int') {
        mask = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/]
        if (other.value) {
            if (other.value.length >= 4) {
                mask = [/[0-9]/, '.', /\d/, /\d/, /\d/, /\d/]
            }
            if (other.value.length >= 5) {
                mask = [/[0-9]/, /\d/, '.', /\d/, /\d/, /\d/]
            }
        }
    }

    if (props.name === 'redirect') {
        mask = [/[0-9]/, /\d/]
    }

    if (props.name === 'perc') {
        mask = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/]
        if (other.value) {
            if (other.value.length >= 3) {
                if(other.value !== '100') {
                    mask = [/[0-9]/, /\d/, '.', /\d/, /\d/]
                }
            }
        }
    }

    if (props.name === 'qtd') {
        mask = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
        if (other.value) {
            if (other.value.length >= 4) {
                mask = [/[0-9]/, '.', /\d/, /\d/, /\d/, /\d/]
            }
            if (other.value.length >= 5) {
                mask = [/[0-9]/, /\d/, '.', /\d/, /\d/, /\d/, /\d/]
            }
            if (other.value.length > 6) {
                mask = [/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/]
            }
            if (other.value.length > 7) {
                mask = [/[0-9]/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/]
            }
            if (other.value.length > 8) {
                mask = [/[0-9]/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/]
            }
        }
    }

    if (props.name === 'money') {
        mask = [/[0-9]/, /\d/, /\d/, /\d/]
        if (other.value) {
            if (other.value.length > 2) {
                mask = [/[0-9]/, '.', /\d/, /\d/, /\d/, /\d/]
            }
            if (other.value.length > 4) {
                mask = [/[0-9]/, /\d/, '.', /\d/, /\d/, /\d/]
            }
            if (other.value.length > 5) {
                mask = [/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/]
            }
        }
    }

    return (
        <MaskedInput
            {...other}
            ref={ref => {
                if(props.name === 'money') {
                    if(ref) {
                        ref.inputElement.value = ref.inputElement.value.includes('.') ? ref.inputElement.value : props.value
                    }
                }
                inputRef(ref ? ref.inputElement : null)
            }}
            mask={mask}
            guide={false}
        />
    )
}

const SortableItem = SortableElement(({ value }) =>
    <div className="bg-img" style={{ backgroundImage: 'url(' + rootUrl + 'thumb/rifa/' + value.img + '?s=' + value.rifa_id + '&h=250&w=250)' }}></div>
);

const SortableList = SortableContainer(({ children }) => {
    return <div id="conteiner" className="row">{children}</div>
});

export default function ActionsEdit(props) {
    const dispatch = useDispatch()
    const { app } = useSelector(state => state.appReducer)
    const { action, error, accounts, status } = useSelector(state => state.actionsReducer)
    const id = (props.uid) ? props.uid : null;

    const [isLoading, setLoading] = React.useState(true)

    const [state, setState] = React.useState({
        isDeleted: null,
        confirmEl: null
    })

    React.useEffect(() => {
        _index()
        return () => {
            dispatch(changeSuccess(false))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const _index = () => {
        if (id) {
            dispatch(show(id)).then(() => setLoading(false))
        }
    }

    return (
        <>
        <AppBar position="fixed">
            <Toolbar>
                <IconButton onClick={() => dispatch(changeScreen({ open: false }))} edge="start" color="inherit">
                    <MdKeyboardBackspace />
                </IconButton>
                <Typography variant="h6">
                    {(id) ? 'Editar Campanha' : 'Nova Campanha'}
                </Typography>
            </Toolbar>
        </AppBar>

        <div className="mt-5 pt-1 bg-clear min-vh-100">
            {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
                <>
                    <div className="card card-body card-border mt-3 bs-bg">
                        <div className="mb-5">
                            <label className="label-custom bs-color-b">Titulo</label>
                            <TextField
                                error={(error.title) && true}
                                value={action.title || ''}
                                placeholder="Ex: Ganhe um iPhone 12 Pro 256 GB"
                            />

                            {(error.title) &&
                                <strong className="text-danger">{error.title[0]}</strong>
                            }
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">1° Prêmio</label>
                            <TextField
                                error={(error.product) && true}
                                value={action.product || ''}
                                placeholder="Ex: iPhone 12 Pro 256 GB"
                            />

                            {(error.product) &&
                                <strong className="text-danger">{error.product[0]}</strong>
                            }
                        </div>

                        {(action.product) &&
                            <div className="mb-3">
                                <label className="label-custom bs-color-b">2° Prêmio</label>
                                <TextField
                                    value={action.product2 || ''}
                                    placeholder="Ex: iPhone 12 Pro 256 GB"
                                />
                            </div>
                        }

                        {(action.product2) &&
                            <div className="mb-3">
                                <label className="label-custom bs-color-b">3° Prêmio</label>
                                <TextField
                                    value={action.product3 || ''}
                                    placeholder="Ex: iPhone 12 Pro 256 GB"
                                />
                            </div>
                        }

                        {(action.product3) &&
                            <div className="mb-3">
                                <label className="label-custom bs-color-b">4° Prêmio</label>
                                <TextField
                                    value={action.product4 || ''}
                                    placeholder="Ex: iPhone 12 Pro 256 GB"
                                />
                            </div>
                        }

                        {(action.product4) &&
                            <div className="mb-3">
                                <label className="label-custom bs-color-b">5° Prêmio</label>
                                <TextField
                                    value={action.product5 || ''}
                                    placeholder="Ex: iPhone 12 Pro 256 GB"
                                />
                            </div>
                        }

                    </div>

                    <div className="card card-body card-border mt-3 bs-bg">
                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Prêmio para quem comprar mais cotas</label>
                            <TextField
                                value={action.product_mais || ''}
                                placeholder="Ex: R$ 1.000 reais no pix"
                            />
                        </div>
                    </div>

                    <div className="card card-body card-border mt-3 bs-bg">

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Data Prevista para o sorteio</label>
                            <div className="date">
                                <label className="label-date bs-color-b">
                                    {(action.prev_sorteio) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(action.prev_sorteio))}&nbsp;&nbsp;&nbsp;
                                    {(action.prev_sorteio) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(action.prev_sorteio))}    
                                </label>
                                <TextField
                                    id="datetime-local"
                                    type="datetime-local"
                                    defaultValue={action.prev_sorteio}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <MdDelete color="#444" size={25} />
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Quantidade de numeros</label>
                                    <TextField
                                        error={(error.numbers) && true}
                                        disabled={(id) && true}
                                        name="qtd"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: (id) ? undefined : TextMaskCustom,
                                            value: (id) ? action.total.toLocaleString('pt-BR', {style: 'decimal'}) : action.numbers,
                                            placeholder: '10.000.000'
                                        }}
                                    />
                                    {(error.numbers) &&
                                        <strong className="text-danger">{error.numbers[0]}</strong>
                                    }
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">PREÇO</label>
                                    <TextField
                                        id="price"
                                        error={(error.price) && true}
                                        name="money"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: action.price || '',
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <strong>R$</strong>
                                                </InputAdornment>
                                            )
                                        }}
                                    />

                                    {(error.price) &&
                                        <strong className="text-danger">{error.price[0]}</strong>
                                    }
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Valor mínimo por compra</label>
                                    <TextField
                                        id="minimum_transaction"
                                        name="money"
                                        type="tel"
                                        error={(error.minimum_transaction) && true}
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: action.minimum_transaction || '',
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <strong>R$</strong>
                                                </InputAdornment>
                                            )
                                        }}
                                    />

                                    {(error.minimum_transaction) &&
                                        <strong className="text-danger">{error.minimum_transaction[0]}</strong>
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Descrição</label>
                            <CKEditor
                                initData={action.description}
                                config={{
                                    toolbar: [
                                        ['Bold', 'Italic'],
                                        ['Format']
                                    ]
                                }}
                            />

                            {(error.description) &&
                                <strong className="text-danger">{error.description[0]}</strong>
                            }
                        </div>
                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Status de Exibição</h3>

                    <div className="card card-body card-border mt-3 bs-bg">
                        <div className="mb-3">
                            <FormControl component="fieldset">
                                <FormLabel className="bs-color" component="legend">Status</FormLabel>
                                <RadioGroup 
                                    aria-label="status_detail" 
                                    name="status_detail" 
                                    value={action.status_detail} 
                                    className="fw-normal bs-color-b"
                                >
                                    {status.map((item, index) => (
                                        <FormControlLabel key={index} value={item.id} control={<Radio color="primary" />} label={item.title} />
                                    ))}
                                </RadioGroup>
                            </FormControl>
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Status</label>
                            <TextField
                                value={action.status_text}
                                placeholder="Ex: Resultado Hoje"
                            />
                        </div>
                        
                        <div className="mb-3">
                            <FormControlLabel
                                className="bs-color-b"
                                control={
                                <Checkbox
                                    checked={(action.emphasis === 'false' || action.emphasis === false || action.emphasis === null ) ? false : true}
                                    color="primary"
                                />
                                }
                                label={<strong>DEIXAR COMO DESTAQUE</strong>}
                            />
                        </div>
                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Banco</h3>

                    <div className="card card-body card-border mt-3 bs-bg">
                        <div className="mb-3">
                            <FormControl component="fieldset">
                                <FormLabel className="bs-color" component="legend">Banco</FormLabel>
                                <RadioGroup 
                                    aria-label="account_id" 
                                    name="account_id" 
                                    value={action.account_id || app.account_id} 
                                    className="fw-normal bs-color-b"
                                >
                                    {accounts.map((item, index) => (
                                        <FormControlLabel key={index} value={item.id} control={<Radio color="primary" />} label={item.title} />
                                    ))}
                                </RadioGroup>
                            </FormControl>
                        </div>
                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Promoção</h3>

                    <div className="card card-body card-border bs-bg">
                        <div className="row">
                            <div className="col-4 col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Quantidade</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: action.qtd1 || '',
                                            placeholder: '3'
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-8 col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">PREÇO</label>
                                    <TextField
                                        id="price2"
                                        name="money"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: action.price2 || '',
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <strong>R$</strong>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-4 col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Quantidade</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: action.qtd2 || '',
                                            placeholder: '5',
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-8 col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">PREÇO</label>
                                    <TextField
                                        id="price3"
                                        name="money"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: action.price3 || '',
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <strong>R$</strong>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-4 col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Quantidade</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: action.qtd3 || '',
                                            placeholder: '7'
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-8 col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">PREÇO</label>
                                    <TextField
                                        id="price4"
                                        name="money"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: action.price4 || '',
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <strong>R$</strong>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Roleta</h3>

                    <div className="card card-body card-border bs-bg">
                        <div className="row">
                            <div className="col-4 col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Qtd. Titulos</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: action.roulette_qtd || '',
                                            placeholder: action.price ? Math.round(5 / action.price) : ''
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-8 col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Giros Roleta</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: action.roulette_spin || '',
                                            placeholder: action.price ? '1' : '',
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <img className="img-fluid me-3" style={{width: '1.5rem'}} src="/roulette.svg"/>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-4 col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Qtd. Titulos</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: action.roulette_qtd2 || '',
                                            placeholder: action.price ? Math.round(5 / action.price) * 2 : ''
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-8 col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Giros Roleta</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: action.roulette_spin2 || '',
                                            placeholder: action.price ? '2' : '',
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <img className="img-fluid me-3" style={{width: '1.5rem'}} src="/roulette.svg"/>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                        <div className="col-4 col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Qtd. Titulos</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: action.roulette_qtd3 || '',
                                            placeholder: action.price ? Math.round(5 / action.price) * 4 : ''
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-8 col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Giros Roleta</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: action.roulette_spin3 || '',
                                            placeholder: action.price ? '4' : '',
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <img className="img-fluid me-3" style={{width: '1.5rem'}} src="/roulette.svg"/>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Quantidade Sugerida de Compra</h3>

                    <div className="card card-body bs-bg">
                        <div className="row">
                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Quantidade</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: action.quantity_suggested_1,
                                            placeholder: '200',
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <strong>+</strong>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="mb-3">
                                <label className="label-custom bs-color-b"><span className="badge bg-success text-uppercase">Recomendada</span></label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: action.quantity_suggested_2,
                                            placeholder: '300',
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <strong>+</strong>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Quantidade</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: action.quantity_suggested_3,
                                            placeholder: '500',
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <strong>+</strong>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Quantidade</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: action.quantity_suggested_4,
                                            placeholder: '1.000',
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <strong>+</strong>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Quantidade</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: action.quantity_suggested_5,
                                            placeholder: '5.000',
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <strong>+</strong>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Quantidade</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: action.quantity_suggested_6,
                                            placeholder: '10.000',
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <strong>+</strong>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Top Comprador</h3>

                    <div className="card card-body card-border mt-3 bs-bg">
                        <div className="mb-3">
                            <FormControl component="fieldset">
                                <FormLabel className="bs-color" component="legend">Exibir na Página da Campanha</FormLabel>
                                <RadioGroup
                                    row
                                    aria-label="top_status" 
                                    name="top_status"
                                    className="fw-normal bs-color-b"
                                    value={action.top_status} 
                                >
                                    <FormControlLabel value={1} control={<Radio color="primary" />} label="Não exibir" />
                                    <FormControlLabel value={2} control={<Radio color="primary" />} label="Exibir" />
                                </RadioGroup>
                            </FormControl>
                        </div>

                        {action.top_status === 2 &&
                            <>
                            <div className="mb-3">
                                <FormControl component="fieldset">
                                    <FormLabel className="bs-color" component="legend">Quantidade</FormLabel>
                                    <RadioGroup
                                        row
                                        aria-label="top_daily" 
                                        name="top_daily"
                                        className="fw-normal bs-color-b"
                                        value={action.top_qtd_users} 
                                    >
                                        <FormControlLabel value={3} control={<Radio color="primary" />} label="TOP 3" />
                                        <FormControlLabel value={5} control={<Radio color="primary" />} label="TOP 5" />
                                        <FormControlLabel value={10} control={<Radio color="primary" />} label="TOP 10" />
                                    </RadioGroup>
                                </FormControl>
                            </div>

                            <div className="mb-3">
                                <FormControl component="fieldset">
                                    <FormLabel className="bs-color" component="legend">Diário ou Personalizado</FormLabel>
                                    <RadioGroup
                                        row
                                        aria-label="top_daily" 
                                        name="top_daily"
                                        className="fw-normal bs-color-b"
                                        value={action.top_daily ? action.top_daily : 0} 
                                    >
                                        <FormControlLabel value={1} control={<Radio color="primary" />} label="Diário" />
                                        <FormControlLabel value={2} control={<Radio color="primary" />} label="Personalizado" />
                                    </RadioGroup>
                                </FormControl>
                            </div>

                            {action.top_daily === 2 &&
                                <div className="row mb-3 mt-2">
                                    <div className="col-6 col-lg-6">
                                        <div className="date">
                                            <label className="label-date bs-color-b">
                                                {(action.top_init_at) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(action.top_init_at))}&nbsp;&nbsp;&nbsp;
                                                {(action.top_init_at) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(action.top_init_at))}    
                                            </label>
                                            <TextField
                                                id="datetime-local"
                                                label="Data Inicial"
                                                type="datetime-local"
                                                defaultValue={action.top_init_at}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-6 col-lg-6">
                                        <div className="date">
                                            <label className="label-date bs-color-b">
                                                {(action.top_end_at) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(action.top_end_at))}&nbsp;&nbsp;&nbsp;
                                                {(action.top_end_at) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(action.top_end_at))}    
                                            </label>
                                            <TextField
                                                id="datetime-local"
                                                label="Data Final"
                                                type="datetime-local"
                                                defaultValue={action.top_end_at}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                            </>
                        }
                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Menor e Maior Cota</h3>
                        <div className="card card-body card-border mt-3 bs-bg">
                            <div className="mb-3">
                                <FormControl component="fieldset">
                                    <FormLabel className="bs-color" component="legend">Exibir na Página da Campanha</FormLabel>
                                    <RadioGroup
                                        row
                                        aria-label="bigger_title_status" 
                                        name="bigger_title_status"
                                        className="fw-normal bs-color-b"
                                        value={action.bigger_title_status} 
                                    >
                                        <FormControlLabel value={1} control={<Radio color="primary" />} label="Não exibir" />
                                        <FormControlLabel value={2} control={<Radio color="primary" />} label="Exibir" />
                                    </RadioGroup>
                                </FormControl>
                            </div>

                            {action.bigger_title_status === 2 &&
                                <>
                                <div className="mb-3">
                                    <FormControl component="fieldset">
                                        <FormLabel className="bs-color" component="legend">Diário ou Personalizado</FormLabel>
                                        <RadioGroup
                                            row
                                            aria-label="bigger_title_daily" 
                                            name="bigger_title_daily"
                                            className="fw-normal bs-color-b"
                                            value={action.bigger_title_daily ? action.bigger_title_daily : 0} 
                                        >
                                            <FormControlLabel value={1} control={<Radio color="primary" />} label="Diário" />
                                            <FormControlLabel value={2} control={<Radio color="primary" />} label="Personalizado" />
                                        </RadioGroup>
                                    </FormControl>
                                    
                                </div>

                                {action.bigger_title_daily === 2 &&
                                    <div className="row mb-3 mt-2">
                                        <div className="col-6 col-lg-6">
                                            <div className="date">
                                                <label className="label-date bs-color-b">
                                                    {(action.bigger_title_init_at) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(action.bigger_title_init_at))}&nbsp;&nbsp;&nbsp;
                                                    {(action.bigger_title_init_at) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(action.bigger_title_init_at))}    
                                                </label>
                                                <TextField
                                                    id="datetime-local"
                                                    label="Data Inicial"
                                                    type="datetime-local"
                                                    defaultValue={action.bigger_title_init_at}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-6 col-lg-6">
                                            <div className="date">
                                                <label className="label-date bs-color-b">
                                                    {(action.bigger_title_end_at) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(action.bigger_title_end_at))}&nbsp;&nbsp;&nbsp;
                                                    {(action.bigger_title_end_at) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(action.bigger_title_end_at))}    
                                                </label>
                                                <TextField
                                                    id="datetime-local"
                                                    label="Data Final"
                                                    type="datetime-local"
                                                    defaultValue={action.bigger_title_end_at}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                }
                                </>
                            }
                        </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Midias Sociais</h3>

                    <div className="card card-body card-border mt-3 bs-bg">
                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Whatsapp</label>
                            <TextField
                                value={action.whatsapp || ''}
                                placeholder="Ex: https://wa.me/5599999999999"
                            />
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Instagram</label>
                            <TextField
                                value={action.instagram || ''}
                                placeholder="Ex: https://www.instagram.com/seuinstagram"
                            />
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Telegram</label>
                            <TextField
                                value={action.telegram || ''}
                                placeholder="Ex: https://t.me/seugrupotelegram"
                            />
                        </div>

                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Reservas</h3>

                    <div className="card card-body bs-bg">
                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Limite de cotas reservadas por cliente</label>
                            <TextField
                                name="int"
                                type="tel"
                                InputProps={{
                                    inputComponent: TextMaskCustom,
                                    value: action.max_reserva,
                                    placeholder: '2000'
                                }}
                            />
                        </div>
                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Marketing</h3>

                    <div className="card card-body bs-bg">
                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Porcentagem</label>
                            <TextField
                                name="perc"
                                type="tel"
                                InputProps={{
                                    inputComponent: TextMaskCustom,
                                    value: action.percent_status,
                                    placeholder: '30',
                                }}
                            />
                        </div>

                        <div className="mb-3">
                            <FormControlLabel
                                className="bs-color-b"
                                control={
                                <Checkbox
                                    checked={(action.percent_view === 'false' || action.percent_view === false || action.percent_view === null ) ? false : true}
                                    color="primary"
                                />
                                }
                                label={<strong>EXIBIR NO SITE</strong>}
                            />
                        </div>
                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Gatilho pós Compra</h3>

                    <div className="card card-body bs-bg">
                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Titulo</label>
                            <TextField
                                value={action.trigger_title || ''}
                                placeholder="Ex: VOCÊ GANHOU !"
                            />
                        </div>
                        
                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Descrição</label>
                            <CKEditor
                                initData={action.trigger_description}
                                config={{
                                    height: 100,
                                    toolbar: [
                                        ['Bold', 'Italic'],
                                        ['Format']
                                    ]
                                }}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Botão</label>
                            <TextField
                                value={action.trigger_button || ''}
                                placeholder="Ex: BOTÃO DA VIRADA DE CHAVE !"
                            />
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Link</label>
                            <TextField
                                value={action.trigger_link || ''}
                                placeholder="https://seulinkexterno.com"
                            />
                        </div>
                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Redirect pós Compra</h3>
                                
                    <div className="card card-body bs-bg">
                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Redirecionar Após</label>
                            <TextField
                                name="redirect"
                                placeholder="Ex: 5 segundos"
                                type="tel"
                                InputProps={{
                                    inputComponent: TextMaskCustom,
                                    value: action.trigger_redirect_time || ''
                                }}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Link</label>
                            <TextField
                                value={action.trigger_redirect_link || ''}
                                placeholder="https://seulinkexterno.com"
                            />
                        </div>
                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Fotos do premio</h3>

                    <div className="card card-body bs-bg">
                        {(error.fotos) &&
                            <strong className="text-danger">{error.fotos[0]}</strong>
                        }

                        <SortableList axis="xy" helperContainer={() => document.getElementById('conteiner')}>
                            {action.fotos.map((item, index) => (
                                <div key={item.id} className="col-6 col-md-4">
                                    <div className="box-image d-flex justify-content-center align-items-center mt-3">
                                        {(state.isDeleted === item.id) ?
                                            <CircularProgress size="30" color="secondary" />
                                            :
                                            <>
                                                <span id={item.id} className="img-action d-flex justify-content-center align-items-center">
                                                    <div className="app-icon d-flex">
                                                        <FaTrash color="#fff" size="1.2em" />
                                                    </div>
                                                </span>
                                                <SortableItem
                                                    key={'item-' + item.id}
                                                    index={index}
                                                    value={item}
                                                />
                                            </>
                                        }
                                    </div>
                                </div>
                            ))}

                        </SortableList>
                    </div>
                </>
            }
        </div>
        </>
    )
}